import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/QuoteForm.css';

const QuoteForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedPackage = queryParams.get('package');
  const packagePrice = queryParams.get('price')?.replace('R', '').replace(',', '') || 0;

  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    websitePackage: selectedPackage || '',
    hostingRequired: 'Yes',
    otherFeatures: [],
  });

  const [totalPrice, setTotalPrice] = useState(Number(packagePrice));
  const [statusMessage, setStatusMessage] = useState('');

  const featureOptions = [
    { label: 'NONE', value: 0 },
    { label: 'Hosting Addon - International Domain – Yearly', value: 185 },
    { label: 'Hosting Addon - 10 Email Accounts – Yearly', value: 565 },
    { label: 'SSL Certificate + Installation', value: 625 },
  ];

  useEffect(() => {
    let extrasTotal = formData.otherFeatures.reduce((acc, feature) => acc + feature, 0);
    setTotalPrice(Number(packagePrice) + extrasTotal);
  }, [formData.otherFeatures, packagePrice]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFeatureChange = (e) => {
    const options = e.target.options;
    let selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        const price = featureOptions.find(opt => opt.label === options[i].value)?.value || 0;
        selected.push(price);
      }
    }
    setFormData(prev => ({ ...prev, otherFeatures: selected }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formPayload = {
      name: formData.name,
      company: formData.company,
      email: formData.email,
      phone: formData.phone,
      websitePackage: formData.websitePackage,
      hostingRequired: formData.hostingRequired,
      features: formData.otherFeatures.map(price => {
        const label = featureOptions.find(opt => opt.value === price)?.label;
        return label || '';
      }).join(', '),
      totalPrice: `R${totalPrice}`,
    };

    try {
      const response = await fetch('https://formspree.io/f/mvgazpnk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formPayload)
      });

      if (response.ok) {
        setStatusMessage('✅ Quote request sent successfully!');
      } else {
        setStatusMessage('❌ Failed to send quote. Please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatusMessage('❌ Failed to send quote. Please check your internet connection.');
    }
  };

  return (
    <div className="quote-form-container">
      <h1>Website Quote Request:</h1>
      <form onSubmit={handleSubmit} className="quote-form">
        <div className="form-group">
          <label>Name *</label>
          <input type="text" name="name" required onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Company *</label>
          <input type="text" name="company" required onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>E-Mail *</label>
          <input type="email" name="email" required onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Phone Number *</label>
          <input type="text" name="phone" required onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Website Package *</label>
          <input type="text" name="websitePackage" value={formData.websitePackage} readOnly />
        </div>
        <div className="form-group">
          <label>Hosting & Domain Required? *</label>
          <select name="hostingRequired" onChange={handleChange}>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>
        <div className="form-group">
          <label>Other Features Wanted? *</label>
          <select multiple name="otherFeatures" onChange={handleFeatureChange}>
            {featureOptions.map((option, idx) => (
              <option key={idx} value={option.label}>{option.label}</option>
            ))}
          </select>
        </div>
        <div className="total-price">
          <strong>Total Quote: R{totalPrice}</strong>
        </div>
        <button type="submit" className="submit-btn">Get Quote</button>
        {statusMessage && <p className="status-message">{statusMessage}</p>}
      </form>
    </div>
  );
};

export default QuoteForm;
